<template>
    <div>
        <div class="container pb-5">
            <div class="pt-5 pb-5 d-flex align-items-center justify-content-between">
                <h1 class="m-0">Winkelen</h1>
            </div>

            <!-- Categories -->
            <div class="row">
                <div class="col-lg-3 mb-30" v-for="category in categories" :key="category.id">
                    <category-preview :category="category"></category-preview>
                </div>
            </div>
            <!-- End Categories -->
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        categories() {
            return this.$store.getters.categories;
        }
    }
};
</script>

